const disableSingleOptionSelects = (bundle) => {
    bundle.querySelectorAll('select').forEach(select => {
        if (select.options.length === 1) {
            select.disabled = true;
        }
    });
};

const startWatching = (bundle) => {
    disableSingleOptionSelects(bundle);
    new MutationObserver(() => disableSingleOptionSelects(bundle))
        .observe(bundle, { childList: true, subtree: true });
};

const waitForBundle = () => {
    const bundle = document.getElementById('appstle-bundle');
    if (bundle) {
        startWatching(bundle);
        return;
    }
    
    const observer = new MutationObserver(() => {
        const bundle = document.getElementById('appstle-bundle');
        if (bundle) {
            observer.disconnect();
            startWatching(bundle);
        }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
};

// Wait for DOM to be ready before running
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForBundle);
} else {
    waitForBundle();
}